import { INavSearchUxXP } from '../../indigofair/seo/INavSearchUxXP';
import { SettingConst } from '../../types';

/**
 * Experiment modifying UX of navigation search:
 * https:www.notion.so/faire/Low-lift-testing-Batch-2-cfd95df3dffe4210a9cf9ef8e68c6da4
 */
export const NAV_SEARCH_UX_240826 = 'NAV_SEARCH_UX_240826' as SettingConst<
  'NAV_SEARCH_UX_240826',
  keyof typeof INavSearchUxXP.Bucket,
  'RETAILER'
>;
